export function subscriptionForRoute(route, userId, options = {}) {
  if (route.name === 'invoice') {
    return {
      name: 'invoices.byToken',
      args: [route.token],
      loadingMessage: 'Loading payable invoice',
    };
  }

  if (route.name === 'pay') {
    return {
      name: 'paymentAttempts.byToken',
      args: [route.token],
      loadingMessage: 'Loading payment intent',
    };
  }

  if (route.name === 'operator') {
    // Identity, the paginated index and selected-invoice detail have independent
    // lifetimes, so App.svelte starts them separately.
    return null;
  }

  return {
    name: 'invoices.openIndex',
    args: [options.page || 1],
    loadingMessage: 'Loading open invoices',
  };
}

export function operatorIdentitySubscription(userId) {
  if (!userId) return null;

  return {
    name: 'operator.identity',
    args: [],
    loadingMessage: 'Loading operator desk',
  };
}

export function operatorInvoicesSubscription(options = {}) {
  return {
    name: 'operator.invoices',
    args: [options.projectId || '', options.page || 1, Boolean(options.archived)],
    loadingMessage: 'Loading operator invoices',
  };
}

export function operatorInvoiceDetailSubscription(invoiceId) {
  if (!invoiceId) return null;

  return {
    name: 'operator.invoiceDetail',
    args: [invoiceId],
    loadingMessage: 'Loading invoice details',
  };
}

export function openInvoiceDetailSubscription(codenameToken) {
  if (!codenameToken) return null;

  return {
    name: 'invoices.openDetail',
    args: [codenameToken],
    loadingMessage: 'Loading invoice details',
  };
}

export function routeIsReadyWithoutSubscription(route, userId) {
  return route.name === 'operator' && !userId;
}
